import { Box, Badge } from "@chakra-ui/react";
import { BaseBlockProps } from "./types";

const statusColors: Record<string, string> = {
  success: "green",
  error: "red",
  warning: "orange",
  info: "blue",
  gray: "gray",
  green: "green",
  red: "red",
  orange: "orange",
  blue: "blue",
  purple: "purple",
  default: "gray",
};

export const StatusBlock = ({ block }: BaseBlockProps) => {
  const content = block.content as { text?: string; color?: string } | string;
  const text = typeof content === "string" ? content : content?.text || "";
  const color = typeof content === "object" ? content?.color : undefined;

  return (
    <Box>
      <Badge
        colorScheme={statusColors[color || "default"] || "gray"}
        fontSize="xs"
        px={2}
        py={0.5}
        borderRadius="component.md"
        variant="subtle"
      >
        {text}
      </Badge>
    </Box>
  );
};
